// lib/i18n.ts
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { defaultNS } from './next-i18next.config'

i18n
  .use(initReactI18next)
  .init({
    lng: 'ar', // or fallback language
    fallbackLng: 'ar',
    defaultNS,
    interpolation: {
      escapeValue: false, // react already escapes
    },
    resources: {
      en: {
        common: {}, // can be empty because next-i18next loads JSON files
      },
      ar: {
        common: {},
      },
    },
  })

export default i18n
